// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("img/rav_background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/n27/n27-regular-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/n27/n27-regular-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/vestula/VestulaPro-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("fonts/vestula/VestulaPro-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("fonts/oscine/Oscine-XBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("fonts/oscine/Oscine-XBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("fonts/oscine/Oscine-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("fonts/oscine/Oscine-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("fonts/oscine/Oscine-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("fonts/oscine/Oscine-Light.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

#doekwrapper {
  resize: both;
  padding: 0px;
  overflow: hidden; /* Overweeg om dit te veranderen als je wilt dat #doekwrapper zelf ook scrollbaar is */
  height: 100vh; /* Dit beperkt de hoogte, wat goed is */
  position: relative;
  background-color: #001158;
}

#doek {
  position: relative;
  background-size: cover;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-color: #fff;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  overflow-y: hidden; /* Of een andere waarde, afhankelijk van je behoefte */
  overflow-x: hidden;
  width: 1250px;
  height: 800px;
  margin: 0;
  border: none; /* Zorgt ervoor dat er geen border is */
  padding: 0;
  box-shadow: none; /* Verwijdert box-shadow indien eerder toegepast */
}

.menu {
  position: absolute;
  width: 100%;
  height: 80px;
  background-color: #eb6741;
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
}

.menu p {
  padding-top: 10px;
  padding-left: 50px;
  color: #001158;
  font-size: 30px;
  font-family: "VestulaPro-Regular";
}

.bolder {
  font-family: "VestulaPro-Bold";
}

#zoekFormulier {
  display: flex;
  justify-content: center;
  align-items: center;
}

#zoekVeld {
  padding: 5px;
  font-size: 25px;
  border: 0px solid #ccc;
  font-family: "Merriweather", serif;
  border-radius: 5px 0 0 5px; /* Afgeronde hoeken aan de linkerkant */
  outline: none; /* Verwijdert de blauwe focus rand */
}

#searchButton {
  padding: 5px 10px;
  font-family: "Merriweather", serif;
  font-size: 25px;
  background-color: #123974; /* Blauwe achtergrond */
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 0 5px 5px 0; /* Afgeronde hoeken aan de rechterkant */
  outline: none; /* Verwijdert de blauwe focus rand */
}

#searchButton:hover {
  background-color: #0056b3; /* Donkerdere blauwe achtergrond bij hover */
}

.logo {
  position: absolute;
  bottom: 0px;
  width: 220px;
}

.logo svg {
  width: 100%;
  height: 100%;
}

.trein,
.bus,
.comments {
  position: absolute;
  width: 500px;
  bottom: 20px;
  font-family: "VestulaPro-Regular";
  color: #001158;
}

.trein {
  left: 20px;
}

.comments {
  right: 10px;
  bottom: 370px;
}

.bus {
  right: 10px;
}

.close_button {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  z-index: 1000;
}

.close_button img {
  width: 100%;
  height: 100%;
}

.marker {
  position: absolute;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
  transition: 0.3s;
}

#yellow {
  background-color: yellow;
  font-family: "Merriweather", serif;
  padding: 10px 20px;
  font-size: 30px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 25;
  display: none;
}

.space {
  margin-bottom: 10px;
}

.icon_image {
  cursor: pointer !important;
}

img {
  width: 100%;
}

.hover {
  cursor: pointer;
}

.taalselectie {
  position: absolute;
  top: 20px;
  right: 20px;
  font-family: "VestulaPro-Bold";
  color: #fff;
  background-color: #001158;
  padding: 5px;
}

.taalselectie a {
  color: #fff;
  text-decoration: none;
}

.taalselectie a:hover {
  color: #eb6741;
}

@font-face {
  font-family: "n27regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "VestulaPro-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "VestulaPro-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: "Oscine XBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Oscine";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Oscine";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
h1 {
  font-family: "Oscine XBold", sans-serif;
  font-size: 40px;
  margin-bottom: 15px;
  color: #001158;
}

.table {
  position: absolute;
  top: 10px;
  width: 2200px !important;
  height: 1500px !important;
  background-color: #ffffff;
  border-radius: 20px;
  padding: 20px;
  z-index: 1;
  overflow: hidden;
}

.popup_img img {
  width: 100%;
}

.table .destination {
  font-size: 50px;
}

.title {
  font-size: 80px;
  font-family: "VestulaPro-Bold";
  color: #001158;
  padding-bottom: 30px;
}

.both_table {
  display: flex;
  justify-content: space-between;
}

.grid-table {
  top: 80px;
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Pas dit aan op basis van het aantal kolommen */
  gap: 5px;
  font-size: 25px;
  font-family: "VestulaPro-Regular";
}

.grid-table {
  display: flex;
  flex-direction: column;
}

.grid-row {
  color: #001158;
  display: flex;
  align-items: stretch; /* Zorgt ervoor dat alle items in de rij dezelfde hoogte hebben */
}

.grid-header {
  display: flex;
  align-items: center; /* Centreert de items verticaal */
  gap: 10px;
  width: 250px;
  color: #001158;
  padding: 5px;
  font-family: "VestulaPro-Bold";
}

.grid-cell {
  display: flex;
  gap: 10px;
  width: 250px;
  color: #001158;
  border: 1px solid #ddd;
  background-color: white;
  padding: 5px;
}

.grid-cell {
  width: 250px !important;
  border: 1px solid #ddd;
  background-color: white;
  padding: 5px;
}

.grid-header, .grid-cell {
  height: 50px; /* Stel een vaste hoogte in */
}

.grid-cell {
  width: 250px;
}

.icon {
  height: 30px;
}

.icon svg {
  width: 100%;
  height: auto;
}

.tableicon {
  display: inline-block;
  width: 30px;
  margin: 0;
  padding: 0;
}

.tableicon img {
  padding-left: 10px;
  transform: translateY(4px);
}

.tableicon svg {
  width: 100%;
  height: auto;
}

.mapicon {
  width: 30px;
  height: 30px;
  transition: width 0.3s ease-in-out; /* Smooth transition toegevoegd */
  cursor: pointer;
}

.mapicon:hover {
  width: 35px; /* Breedte iets groter bij hover */
}

.mapicon svg {
  width: 100%;
  height: auto;
}

.marker {
  /* background-color: white; */
  font-family: "Merriweather", serif;
  width: auto;
  height: 40px;
  border-radius: 0;
}

.marker_text {
  background-color: white;
  padding: 10px;
  font-size: 15px;
  font-family: "Merriweather", serif;
  color: #001158;
  border-radius: 10px;
  display: none;
}

.tabel_opgemaakt {
  width: 100%;
  border-collapse: collapse;
  font-family: "VestulaPro-Regular";
}

.popup_img {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 210px;
}

.tabel_opgemaakt th,
.tabel_opgemaakt td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #001158;
}

.tabel_opgemaakt th {
  background-color: #f2f2f2;
}

.tabel_opgemaakt tr:hover {
  background-color: #f5f5f5;
}

.tabel_opgemaakt th {
  background-color: #f2f2f2;
  color: #001158;
}

.tablecontainer {
  height: 490px;
  overflow-y: scroll;
}

.co2::after {
  content: "2";
  vertical-align: sub;
  font-size: smaller;
}

.video-container {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.mp4-container {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
}

.mp4-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.info {
  position: absolute;
  top: 90px;
  width: 94.45%;
  bottom: 40px;
  left: 80px;
  padding-right: 15px;
  overflow-y: auto !important;
}

.info .button {
  display: inline-block;
  padding: 10px;
  background-color: #7199f0;
  color: white;
  text-decoration: none;
  border-radius: 10px;
  margin-top: 10px;
  margin-bottom: 50vh;
}

.info a:hover {
  background-color: #555;
}

/* Scrollbar track */
.info::-webkit-scrollbar {
  width: 12px; /* Width of the scrollbar */
}

.info::-webkit-scrollbar-track {
  background: #f1f1f1; /* Background of the scrollbar track */
}

/* Scrollbar thumb */
.info::-webkit-scrollbar-thumb {
  background: #888; /* Color of the scrollbar thumb */
  border-radius: 6px; /* Rounded corners for the scrollbar thumb */
}

.info h1 {
  font-size: 100px;
  font-family: "Montserrat", sans-serif;
  color: #0063a4;
  margin-bottom: 20px;
}

.info h2 {
  font-size: 50px;
  line-height: 52px;
  margin-bottom: 15px;
  font-family: "Montserrat", sans-serif;
  color: #0063a4;
  padding-top: 30px;
  margin-bottom: 10px;
}

.info h3 {
  font-size: 30px;
  margin-bottom: 10px;
  font-family: "Montserrat", sans-serif;
  color: #0063a4;
}

.info h4 {
  font-size: 30px;
  background-color: #0063a4;
  color: white;
}

.info p, li {
  font-size: 45px;
  line-height: 60px !important;
  font-family: "Montserrat", sans-serif;
  margin-bottom: 10px !important;
  padding: 0 !important;
}

@media screen and (min-width: 1000px) {
  .info p, li {
    font-size: 40px;
    line-height: 60px !important;
  }
}
.info ul {
  list-style-type: disc;
  padding-left: 30px;
}

.opening {
  position: absolute;
  top: 12px;
  left: 20px;
}

.opening h1 {
  font-family: "VestulaPro-Bold";
  font-size: 70px;
  color: #001158;
  margin: 0;
  padding: 0;
}

.opening p {
  font-family: "Merriweather", serif;
  font-size: 18px;
  padding-left: 3px;
}

.ring-container {
  position: relative;
  width: 24px;
  height: 24px;
}

.ring {
  position: absolute;
  border: 4px solid rgba(255, 0, 0, 0.5);
  border-radius: 50%;
  width: 100%;
  height: 100%;
  animation: ring-animation 1.5s infinite;
}

.ring:nth-child(2) {
  animation-delay: 0.5s;
}

.ring:nth-child(3) {
  animation-delay: 1s;
}

@keyframes ring-animation {
  0% {
    transform: scale(0.5);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
.startpopup {
  position: absolute; /* Veranderd naar absolute voor centrering */
  top: 50%; /* Centreren verticaal */
  left: 50%; /* Centreren horizontaal */
  transform: translate(-50%, -50%); /* Aanpassing om precies in het midden te centreren */
  width: 1500px;
  height: 850px;
  z-index: 100;
  background-color: brown;
  display: grid;
  align-items: center; /* Zorgt dat de inhoud ook verticaal gecentreerd is binnen de popup */
  justify-content: center; /* Zorgt dat de inhoud ook horizontaal gecentreerd is binnen de popup */
  border-radius: 20px;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 17, 88, 0.5);
}

.markertext {
  position: absolute;
  top: -60px;
  background-color: white;
  font-family: "Oscine", sans-serif;
  padding: 10px 20px;
  font-size: 25px;
  color: black;
  border-radius: 10px;
  width: auto;
}`, "",{"version":3,"sources":["webpack://./src/sass/02_layout/_basis.scss","webpack://./src/sass/02_layout/index.scss","webpack://./src/sass/02_layout/_fonts.scss","webpack://./src/sass/02_layout/_table.scss","webpack://./src/sass/02_layout/_info.scss","webpack://./src/sass/02_layout/_opening.scss","webpack://./src/sass/02_layout/_rings.scss","webpack://./src/sass/02_layout/_startpopup.scss","webpack://./src/sass/02_layout/_overlay.scss","webpack://./src/sass/02_layout/_markertext.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,SAAA;EACA,sBAAA;ACCJ;;ADGA;EACI,YAAA;EACA,YAAA;EACA,gBAAA,EAAA,sFAAA;EACA,aAAA,EAAA,uCAAA;EACA,kBAAA;EACA,yBAAA;ACAJ;;ADGA;EACI,kBAAA;EACA,sBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,kBAAA,EAAA,sDAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA,EAAA,uCAAA;EACA,UAAA;EACA,gBAAA,EAAA,kDAAA;ACAJ;;ADGA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;ACAJ;;ADGA;EACI,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,iCAAA;ACAJ;;ADGA;EACI,8BAAA;ACAJ;;ADGA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;ACAJ;;ADGA;EACI,YAAA;EACA,eAAA;EACA,sBAAA;EACA,kCAAA;EACA,0BAAA,EAAA,uCAAA;EACA,aAAA,EAAA,oCAAA;ACAJ;;ADGA;EACI,iBAAA;EACA,kCAAA;EACA,eAAA;EACA,yBAAA,EAAA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA,EAAA,wCAAA;EACA,aAAA,EAAA,oCAAA;ACAJ;;ADGA;EACI,yBAAA,EAAA,4CAAA;ACAJ;;ADGA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;ACAJ;;ADGA;EACI,WAAA;EACA,YAAA;ACAJ;;ADGA;;;EAGI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,iCAAA;EACA,cAAA;ACAJ;;ADGA;EACI,UAAA;ACAJ;;ADGA;EACI,WAAA;EACA,aAAA;ACAJ;;ADGA;EACI,WAAA;ACAJ;;ADGA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;ACAJ;;ADGA;EACI,WAAA;EACA,YAAA;ACAJ;;ADGA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;ACAJ;;ADKA;EACI,wBAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;ACFJ;;ADMA;EACI,mBAAA;ACHJ;;ADMA;EAEI,0BAAA;ACJJ;;ADQA;EACI,WAAA;ACLJ;;ADeA;EACI,eAAA;ACZJ;;ADeA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,8BAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;ACZJ;;ADeA;EACI,WAAA;EACA,qBAAA;ACZJ;;ADeA;EACI,cAAA;ACZJ;;AC7LA;EACI,yBAAA;EACA,4CAAA;EACA,oIAAA;EAEA,mBAAA;EACA,kBAAA;AD+LJ;AC5LA;EACI,iCAAA;EACA,2DAAA;EACA,mBAAA;EACA,kBAAA;AD8LJ;AC3LA;EACI,8BAAA;EACA,2DAAA;EACA,iBAAA;EACA,kBAAA;AD6LJ;AC1LA;EACI,2BAAA;EACA,oHAAA;EAEA,iBAAA;EACA,kBAAA;EACA,kBAAA;AD2LJ;ACxLA;EACI,qBAAA;EACA,oHAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kBAAA;ADyLJ;ACtLA;EACI,qBAAA;EACA,sHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADuLJ;ACjLA;EACI,uCAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;ADmLJ;;AE5OA;EACI,kBAAA;EACA,SAAA;EACA,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EAEA,UAAA;EACA,gBAAA;AF8OJ;;AE1OA;EACI,WAAA;AF6OJ;;AE1OA;EACI,eAAA;AF6OJ;;AE1OA;EACI,eAAA;EACA,8BAAA;EACA,cAAA;EACA,oBAAA;AF6OJ;;AE1OA;EACI,aAAA;EACA,8BAAA;AF6OJ;;AEzOA;EACI,SAAA;EACA,aAAA;EACA,qCAAA,EAAA,iDAAA;EACA,QAAA;EACA,eAAA;EACA,iCAAA;AF4OJ;;AExOA;EACI,aAAA;EACA,sBAAA;AF2OJ;;AExOA;EACI,cAAA;EACA,aAAA;EACA,oBAAA,EAAA,iEAAA;AF2OJ;;AEtOA;EACI,aAAA;EACA,mBAAA,EAAA,iCAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,8BAAA;AFyOJ;;AEtOA;EACI,aAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AFyOJ;;AEtOA;EAEI,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AFwOJ;;AErOA;EACI,YAAA,EAAA,6BAAA;AFwOJ;;AEpOA;EACI,YAAA;AFuOJ;;AEpOA;EACI,YAAA;AFuOJ;;AEpOA;EACI,WAAA;EACA,YAAA;AFuOJ;;AEnOA;EACI,qBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AFsOJ;;AEnOA;EACI,kBAAA;EACA,0BAAA;AFsOJ;;AEnOA;EACI,WAAA;EACA,YAAA;AFsOJ;;AEnOA;EACI,WAAA;EACA,YAAA;EACA,kCAAA,EAAA,iCAAA;EACA,eAAA;AFsOJ;;AEnOA;EACI,WAAA,EAAA,kCAAA;AFsOJ;;AEnOA;EACI,WAAA;EACA,YAAA;AFsOJ;;AEnOA;EACI,6BAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AFsOJ;;AEpOA;EACI,uBAAA;EACA,aAAA;EACA,eAAA;EACA,kCAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;AFuOJ;;AEpOA;EACI,WAAA;EACA,yBAAA;EACA,iCAAA;AFuOJ;;AEnOA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AFsOJ;;AElOA;;EAEI,YAAA;EACA,gBAAA;EACA,gCAAA;AFqOJ;;AElOA;EACI,yBAAA;AFqOJ;;AElOA;EACI,yBAAA;AFqOJ;;AEjOA;EACI,yBAAA;EACA,cAAA;AFoOJ;;AEjOA;EACI,aAAA;EACA,kBAAA;AFoOJ;;AEjOA;EACI,YAAA;EACA,mBAAA;EACA,kBAAA;AFoOJ;;AEhOA;EACI,kBAAA;EACA,sBAAA,EAAA,sBAAA;EACA,SAAA;EACA,gBAAA;AFmOJ;;AEhOA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AFmOJ;;AEhOA;EACI,kBAAA;EACA,sBAAA,EAAA,sBAAA;EACA,SAAA;EACA,gBAAA;AFmOJ;;AEhOA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AFmOJ;;AGzcA;EACI,kBAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,2BAAA;AH4cJ;;AGzcA;EACI,qBAAA;EACA,aAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AH4cJ;;AGzcA;EACI,sBAAA;AH4cJ;;AGzcA,oBAAA;AACA;EACI,WAAA,EAAA,2BAAA;AH4cJ;;AGzcA;EACI,mBAAA,EAAA,sCAAA;AH4cJ;;AGzcA,oBAAA;AACA;EACI,gBAAA,EAAA,iCAAA;EACA,kBAAA,EAAA,4CAAA;AH4cJ;;AGxcA;EACI,gBAAA;EACA,qCAAA;EACA,cAAA;EACA,mBAAA;AH2cJ;;AGxcA;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,qCAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AH2cJ;;AGxcA;EACI,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,cAAA;AH2cJ;;AGxcA;EACI,eAAA;EACA,yBAAA;EACA,YAAA;AH2cJ;;AGxcA;EACI,eAAA;EACA,4BAAA;EACA,qCAAA;EACA,8BAAA;EACA,qBAAA;AH2cJ;;AGvcA;EACI;IACI,eAAA;IACA,4BAAA;EH0cN;AACF;AGrcA;EACI,qBAAA;EACA,kBAAA;AHucJ;;AIliBA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;AJqiBJ;;AIliBA;EACI,8BAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;AJqiBJ;;AIliBA;EACI,kCAAA;EACA,eAAA;EACA,iBAAA;AJqiBJ;;AKtjBA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;ALyjBJ;;AKtjBE;EACE,kBAAA;EACA,sCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;ALyjBJ;;AKtjBE;EACE,qBAAA;ALyjBJ;;AKtjBE;EACE,mBAAA;ALyjBJ;;AKtjBE;EACE;IACE,qBAAA;IACA,UAAA;ELyjBJ;EKvjBE;IACE,UAAA;ELyjBJ;EKvjBE;IACE,mBAAA;IACA,UAAA;ELyjBJ;AACF;AM3lBA;EACI,kBAAA,EAAA,4CAAA;EACA,QAAA,EAAA,wBAAA;EACA,SAAA,EAAA,0BAAA;EACA,gCAAA,EAAA,qDAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA,EAAA,qEAAA;EACA,uBAAA,EAAA,uEAAA;EACA,mBAAA;AN6lBJ;;AOzmBA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sCAAA;AP4mBJ;;AQlnBA;EACI,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;ARqnBJ","sourcesContent":["* {\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n}\n\n\n#doekwrapper {\n    resize: both;\n    padding: 0px;\n    overflow: hidden; /* Overweeg om dit te veranderen als je wilt dat #doekwrapper zelf ook scrollbaar is */\n    height: 100vh; /* Dit beperkt de hoogte, wat goed is */\n    position: relative;\n    background-color: #001158;\n}\n\n#doek {\n    position: relative;\n    background-size: cover;\n    background-image: url('img/rav_background.png');\n    background-repeat: no-repeat;\n    background-color: #fff;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    overflow-y: hidden; /* Of een andere waarde, afhankelijk van je behoefte */\n    overflow-x: hidden;\n    width: 1250px;\n    height: 800px;\n    margin: 0;\n    border: none; /* Zorgt ervoor dat er geen border is */\n    padding: 0;\n    box-shadow: none; /* Verwijdert box-shadow indien eerder toegepast */\n}\n\n.menu {\n    position: absolute;\n    width: 100%;\n    height: 80px;\n    background-color: #eb6741;\n    display: flex;\n    justify-content: space-between;\n    padding: 12px 15px;\n}\n\n.menu p {\n    padding-top: 10px;\n    padding-left: 50px;\n    color: #001158;\n    font-size: 30px;\n    font-family: 'VestulaPro-Regular';\n}\n\n.bolder {\n    font-family: 'VestulaPro-Bold';\n}\n\n#zoekFormulier {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n#zoekVeld {\n    padding: 5px;\n    font-size: 25px;\n    border: 0px solid #ccc;\n    font-family: \"Merriweather\", serif;\n    border-radius: 5px 0 0 5px; /* Afgeronde hoeken aan de linkerkant */\n    outline: none; /* Verwijdert de blauwe focus rand */\n}\n\n#searchButton {\n    padding: 5px 10px;\n    font-family: \"Merriweather\", serif;\n    font-size: 25px;\n    background-color: #123974; /* Blauwe achtergrond */\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 0 5px 5px 0; /* Afgeronde hoeken aan de rechterkant */\n    outline: none; /* Verwijdert de blauwe focus rand */\n}\n\n#searchButton:hover {\n    background-color: #0056b3; /* Donkerdere blauwe achtergrond bij hover */\n}\n\n.logo {\n    position: absolute;\n    bottom: 0px;\n    width: 220px;\n}\n\n.logo svg {\n    width: 100%;\n    height: 100%;\n}\n\n.trein,\n.bus,\n.comments {\n    position: absolute;\n    width: 500px;\n    bottom: 20px;\n    font-family: 'VestulaPro-Regular';\n    color: #001158;\n}\n\n.trein {\n    left: 20px;\n}\n\n.comments {\n    right: 10px;\n    bottom: 370px;\n}\n\n.bus {\n    right: 10px;\n}\n\n.close_button {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    width: 60px;\n    height: 60px;\n    z-index: 1000;\n}\n\n.close_button img {\n    width: 100%;\n    height: 100%;\n}\n\n.marker {\n    position: absolute;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    cursor: pointer;\n    transition: 0.3s;\n}\n\n\n\n#yellow {\n    background-color: yellow;\n    font-family: \"Merriweather\", serif;\n    padding: 10px 20px;\n    font-size: 30px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 25;\n    display: none;\n}\n\n\n.space {\n    margin-bottom: 10px;\n}\n\n.icon_image {\n    // width: 300px;\n    cursor: pointer!important;\n}\n\n\nimg {\n    width: 100%;\n}\n// .icon_image img {\n//     width: 90px;\n//     height: 90px;\n//     margin-right: 10px;\n//     cursor: pointer;\n// }\n\n\n.hover {\n    cursor: pointer;\n}\n\n.taalselectie {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    font-family: 'VestulaPro-Bold';\n    color: #fff;\n    background-color: #001158;\n    padding: 5px;\n}\n\n.taalselectie a {\n    color: #fff;\n    text-decoration: none;\n}\n\n.taalselectie a:hover {\n    color: #eb6741;\n}","* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n#doekwrapper {\n  resize: both;\n  padding: 0px;\n  overflow: hidden; /* Overweeg om dit te veranderen als je wilt dat #doekwrapper zelf ook scrollbaar is */\n  height: 100vh; /* Dit beperkt de hoogte, wat goed is */\n  position: relative;\n  background-color: #001158;\n}\n\n#doek {\n  position: relative;\n  background-size: cover;\n  background-image: url(\"img/rav_background.png\");\n  background-repeat: no-repeat;\n  background-color: #fff;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  overflow-y: hidden; /* Of een andere waarde, afhankelijk van je behoefte */\n  overflow-x: hidden;\n  width: 1250px;\n  height: 800px;\n  margin: 0;\n  border: none; /* Zorgt ervoor dat er geen border is */\n  padding: 0;\n  box-shadow: none; /* Verwijdert box-shadow indien eerder toegepast */\n}\n\n.menu {\n  position: absolute;\n  width: 100%;\n  height: 80px;\n  background-color: #eb6741;\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 15px;\n}\n\n.menu p {\n  padding-top: 10px;\n  padding-left: 50px;\n  color: #001158;\n  font-size: 30px;\n  font-family: \"VestulaPro-Regular\";\n}\n\n.bolder {\n  font-family: \"VestulaPro-Bold\";\n}\n\n#zoekFormulier {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n#zoekVeld {\n  padding: 5px;\n  font-size: 25px;\n  border: 0px solid #ccc;\n  font-family: \"Merriweather\", serif;\n  border-radius: 5px 0 0 5px; /* Afgeronde hoeken aan de linkerkant */\n  outline: none; /* Verwijdert de blauwe focus rand */\n}\n\n#searchButton {\n  padding: 5px 10px;\n  font-family: \"Merriweather\", serif;\n  font-size: 25px;\n  background-color: #123974; /* Blauwe achtergrond */\n  color: white;\n  border: none;\n  cursor: pointer;\n  border-radius: 0 5px 5px 0; /* Afgeronde hoeken aan de rechterkant */\n  outline: none; /* Verwijdert de blauwe focus rand */\n}\n\n#searchButton:hover {\n  background-color: #0056b3; /* Donkerdere blauwe achtergrond bij hover */\n}\n\n.logo {\n  position: absolute;\n  bottom: 0px;\n  width: 220px;\n}\n\n.logo svg {\n  width: 100%;\n  height: 100%;\n}\n\n.trein,\n.bus,\n.comments {\n  position: absolute;\n  width: 500px;\n  bottom: 20px;\n  font-family: \"VestulaPro-Regular\";\n  color: #001158;\n}\n\n.trein {\n  left: 20px;\n}\n\n.comments {\n  right: 10px;\n  bottom: 370px;\n}\n\n.bus {\n  right: 10px;\n}\n\n.close_button {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  width: 60px;\n  height: 60px;\n  z-index: 1000;\n}\n\n.close_button img {\n  width: 100%;\n  height: 100%;\n}\n\n.marker {\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n#yellow {\n  background-color: yellow;\n  font-family: \"Merriweather\", serif;\n  padding: 10px 20px;\n  font-size: 30px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 25;\n  display: none;\n}\n\n.space {\n  margin-bottom: 10px;\n}\n\n.icon_image {\n  cursor: pointer !important;\n}\n\nimg {\n  width: 100%;\n}\n\n.hover {\n  cursor: pointer;\n}\n\n.taalselectie {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  font-family: \"VestulaPro-Bold\";\n  color: #fff;\n  background-color: #001158;\n  padding: 5px;\n}\n\n.taalselectie a {\n  color: #fff;\n  text-decoration: none;\n}\n\n.taalselectie a:hover {\n  color: #eb6741;\n}\n\n@font-face {\n  font-family: \"n27regular\";\n  src: url(\"fonts/n27/n27-regular-webfont.eot\");\n  src: url(\"fonts/n27/n27-regular-webfont.eot?#iefix\") format(\"embedded-opentype\"), url(\"fonts/n27/n27-regular-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"VestulaPro-Regular\";\n  src: url(\"fonts/vestula/VestulaPro-Regular.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"VestulaPro-Bold\";\n  src: url(\"fonts/vestula/VestulaPro-Bold.woff\") format(\"woff\");\n  font-weight: bold;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Oscine XBold\";\n  src: url(\"fonts/oscine/Oscine-XBold.woff2\") format(\"woff2\"), url(\"fonts/oscine/Oscine-XBold.woff\") format(\"woff\");\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: \"Oscine\";\n  src: url(\"fonts/oscine/Oscine-Regular.woff2\") format(\"woff2\"), url(\"fonts/oscine/Oscine-Regular.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: \"Oscine\";\n  src: url(\"fonts/oscine/Oscine-Light.woff2\") format(\"woff2\"), url(\"fonts/oscine/Oscine-Light.woff\") format(\"woff\");\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\nh1 {\n  font-family: \"Oscine XBold\", sans-serif;\n  font-size: 40px;\n  margin-bottom: 15px;\n  color: #001158;\n}\n\n.table {\n  position: absolute;\n  top: 10px;\n  width: 2200px !important;\n  height: 1500px !important;\n  background-color: #ffffff;\n  border-radius: 20px;\n  padding: 20px;\n  z-index: 1;\n  overflow: hidden;\n}\n\n.popup_img img {\n  width: 100%;\n}\n\n.table .destination {\n  font-size: 50px;\n}\n\n.title {\n  font-size: 80px;\n  font-family: \"VestulaPro-Bold\";\n  color: #001158;\n  padding-bottom: 30px;\n}\n\n.both_table {\n  display: flex;\n  justify-content: space-between;\n}\n\n.grid-table {\n  top: 80px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr); /* Pas dit aan op basis van het aantal kolommen */\n  gap: 5px;\n  font-size: 25px;\n  font-family: \"VestulaPro-Regular\";\n}\n\n.grid-table {\n  display: flex;\n  flex-direction: column;\n}\n\n.grid-row {\n  color: #001158;\n  display: flex;\n  align-items: stretch; /* Zorgt ervoor dat alle items in de rij dezelfde hoogte hebben */\n}\n\n.grid-header {\n  display: flex;\n  align-items: center; /* Centreert de items verticaal */\n  gap: 10px;\n  width: 250px;\n  color: #001158;\n  padding: 5px;\n  font-family: \"VestulaPro-Bold\";\n}\n\n.grid-cell {\n  display: flex;\n  gap: 10px;\n  width: 250px;\n  color: #001158;\n  border: 1px solid #ddd;\n  background-color: white;\n  padding: 5px;\n}\n\n.grid-cell {\n  width: 250px !important;\n  border: 1px solid #ddd;\n  background-color: white;\n  padding: 5px;\n}\n\n.grid-header, .grid-cell {\n  height: 50px; /* Stel een vaste hoogte in */\n}\n\n.grid-cell {\n  width: 250px;\n}\n\n.icon {\n  height: 30px;\n}\n\n.icon svg {\n  width: 100%;\n  height: auto;\n}\n\n.tableicon {\n  display: inline-block;\n  width: 30px;\n  margin: 0;\n  padding: 0;\n}\n\n.tableicon img {\n  padding-left: 10px;\n  transform: translateY(4px);\n}\n\n.tableicon svg {\n  width: 100%;\n  height: auto;\n}\n\n.mapicon {\n  width: 30px;\n  height: 30px;\n  transition: width 0.3s ease-in-out; /* Smooth transition toegevoegd */\n  cursor: pointer;\n}\n\n.mapicon:hover {\n  width: 35px; /* Breedte iets groter bij hover */\n}\n\n.mapicon svg {\n  width: 100%;\n  height: auto;\n}\n\n.marker {\n  /* background-color: white; */\n  font-family: \"Merriweather\", serif;\n  width: auto;\n  height: 40px;\n  border-radius: 0;\n}\n\n.marker_text {\n  background-color: white;\n  padding: 10px;\n  font-size: 15px;\n  font-family: \"Merriweather\", serif;\n  color: #001158;\n  border-radius: 10px;\n  display: none;\n}\n\n.tabel_opgemaakt {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: \"VestulaPro-Regular\";\n}\n\n.popup_img {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 210px;\n}\n\n.tabel_opgemaakt th,\n.tabel_opgemaakt td {\n  padding: 8px;\n  text-align: left;\n  border-bottom: 1px solid #001158;\n}\n\n.tabel_opgemaakt th {\n  background-color: #f2f2f2;\n}\n\n.tabel_opgemaakt tr:hover {\n  background-color: #f5f5f5;\n}\n\n.tabel_opgemaakt th {\n  background-color: #f2f2f2;\n  color: #001158;\n}\n\n.tablecontainer {\n  height: 490px;\n  overflow-y: scroll;\n}\n\n.co2::after {\n  content: \"2\";\n  vertical-align: sub;\n  font-size: smaller;\n}\n\n.video-container {\n  position: relative;\n  padding-bottom: 56.25%; /* 16:9 aspect ratio */\n  height: 0;\n  overflow: hidden;\n}\n\n.video-container iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.mp4-container {\n  position: relative;\n  padding-bottom: 56.25%; /* 16:9 aspect ratio */\n  height: 0;\n  overflow: hidden;\n}\n\n.mp4-container iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.info {\n  position: absolute;\n  top: 90px;\n  width: 94.45%;\n  bottom: 40px;\n  left: 80px;\n  padding-right: 15px;\n  overflow-y: auto !important;\n}\n\n.info .button {\n  display: inline-block;\n  padding: 10px;\n  background-color: #7199f0;\n  color: white;\n  text-decoration: none;\n  border-radius: 10px;\n  margin-top: 10px;\n  margin-bottom: 50vh;\n}\n\n.info a:hover {\n  background-color: #555;\n}\n\n/* Scrollbar track */\n.info::-webkit-scrollbar {\n  width: 12px; /* Width of the scrollbar */\n}\n\n.info::-webkit-scrollbar-track {\n  background: #f1f1f1; /* Background of the scrollbar track */\n}\n\n/* Scrollbar thumb */\n.info::-webkit-scrollbar-thumb {\n  background: #888; /* Color of the scrollbar thumb */\n  border-radius: 6px; /* Rounded corners for the scrollbar thumb */\n}\n\n.info h1 {\n  font-size: 100px;\n  font-family: \"Montserrat\", sans-serif;\n  color: #0063a4;\n  margin-bottom: 20px;\n}\n\n.info h2 {\n  font-size: 50px;\n  line-height: 52px;\n  margin-bottom: 15px;\n  font-family: \"Montserrat\", sans-serif;\n  color: #0063a4;\n  padding-top: 30px;\n  margin-bottom: 10px;\n}\n\n.info h3 {\n  font-size: 30px;\n  margin-bottom: 10px;\n  font-family: \"Montserrat\", sans-serif;\n  color: #0063a4;\n}\n\n.info h4 {\n  font-size: 30px;\n  background-color: #0063a4;\n  color: white;\n}\n\n.info p, li {\n  font-size: 45px;\n  line-height: 60px !important;\n  font-family: \"Montserrat\", sans-serif;\n  margin-bottom: 10px !important;\n  padding: 0 !important;\n}\n\n@media screen and (min-width: 1000px) {\n  .info p, li {\n    font-size: 40px;\n    line-height: 60px !important;\n  }\n}\n.info ul {\n  list-style-type: disc;\n  padding-left: 30px;\n}\n\n.opening {\n  position: absolute;\n  top: 12px;\n  left: 20px;\n}\n\n.opening h1 {\n  font-family: \"VestulaPro-Bold\";\n  font-size: 70px;\n  color: #001158;\n  margin: 0;\n  padding: 0;\n}\n\n.opening p {\n  font-family: \"Merriweather\", serif;\n  font-size: 18px;\n  padding-left: 3px;\n}\n\n.ring-container {\n  position: relative;\n  width: 24px;\n  height: 24px;\n}\n\n.ring {\n  position: absolute;\n  border: 4px solid rgba(255, 0, 0, 0.5);\n  border-radius: 50%;\n  width: 100%;\n  height: 100%;\n  animation: ring-animation 1.5s infinite;\n}\n\n.ring:nth-child(2) {\n  animation-delay: 0.5s;\n}\n\n.ring:nth-child(3) {\n  animation-delay: 1s;\n}\n\n@keyframes ring-animation {\n  0% {\n    transform: scale(0.5);\n    opacity: 1;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    transform: scale(2);\n    opacity: 0;\n  }\n}\n.startpopup {\n  position: absolute; /* Veranderd naar absolute voor centrering */\n  top: 50%; /* Centreren verticaal */\n  left: 50%; /* Centreren horizontaal */\n  transform: translate(-50%, -50%); /* Aanpassing om precies in het midden te centreren */\n  width: 1500px;\n  height: 850px;\n  z-index: 100;\n  background-color: brown;\n  display: grid;\n  align-items: center; /* Zorgt dat de inhoud ook verticaal gecentreerd is binnen de popup */\n  justify-content: center; /* Zorgt dat de inhoud ook horizontaal gecentreerd is binnen de popup */\n  border-radius: 20px;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 17, 88, 0.5);\n}\n\n.markertext {\n  position: absolute;\n  top: -60px;\n  background-color: white;\n  font-family: \"Oscine\", sans-serif;\n  padding: 10px 20px;\n  font-size: 25px;\n  color: black;\n  border-radius: 10px;\n  width: auto;\n}","@font-face {\n    font-family: 'n27regular';\n    src: url('fonts/n27/n27-regular-webfont.eot');\n    src: url('fonts/n27/n27-regular-webfont.eot?#iefix') format('embedded-opentype'),\n         url('fonts/n27/n27-regular-webfont.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'VestulaPro-Regular';\n    src: url('fonts/vestula/VestulaPro-Regular.woff') format('woff');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'VestulaPro-Bold';\n    src: url('fonts/vestula/VestulaPro-Bold.woff') format('woff');\n    font-weight: bold;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Oscine XBold';\n    src: url('fonts/oscine/Oscine-XBold.woff2') format('woff2'),\n        url('fonts/oscine/Oscine-XBold.woff') format('woff');\n    font-weight: bold;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Oscine';\n    src: url('fonts/oscine/Oscine-Regular.woff2') format('woff2'),\n        url('fonts/oscine/Oscine-Regular.woff') format('woff');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Oscine';\n    src: url('fonts/oscine/Oscine-Light.woff2') format('woff2'),\n        url('fonts/oscine/Oscine-Light.woff') format('woff');\n    font-weight: 300;\n    font-style: normal;\n    font-display: swap;\n}\n\n\n\n\nh1 {\n    font-family: 'Oscine XBold', sans-serif;\n    font-size: 40px;\n    margin-bottom: 15px;\n    color: #001158;\n}",".table {\n    position: absolute;\n    top: 10px;\n    width: 2200px!important;\n    height: 1500px!important;\n    background-color: #ffffff;\n    border-radius: 20px;\n    padding: 20px;\n    // box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.6);\n    z-index: 1;\n    overflow: hidden;\n}\n\n\n.popup_img img {\n    width: 100%;\n}   \n\n.table .destination {\n    font-size: 50px;\n}\n\n.title {\n    font-size: 80px;\n    font-family: 'VestulaPro-Bold';\n    color: #001158;\n    padding-bottom: 30px;\n}\n\n.both_table {\n    display: flex;\n    justify-content: space-between;\n\n}\n\n.grid-table {\n    top: 80px;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr); /* Pas dit aan op basis van het aantal kolommen */\n    gap: 5px;\n    font-size: 25px;\n    font-family: 'VestulaPro-Regular';\n}\n\n\n.grid-table {\n    display: flex;\n    flex-direction: column;\n}\n\n.grid-row {\n    color: #001158;\n    display: flex;\n    align-items: stretch; /* Zorgt ervoor dat alle items in de rij dezelfde hoogte hebben */\n}\n\n\n\n.grid-header {\n    display: flex;\n    align-items: center; /* Centreert de items verticaal */\n    gap: 10px;\n    width: 250px;\n    color: #001158;\n    padding: 5px;\n    font-family: 'VestulaPro-Bold';\n}\n\n.grid-cell {\n    display: flex;\n    gap: 10px;\n    width: 250px;\n    color: #001158;\n    border: 1px solid #ddd;\n    background-color: white;\n    padding: 5px;\n}\n\n.grid-cell {\n    \n    width: 250px!important;\n    border: 1px solid #ddd;\n    background-color: white;\n    padding: 5px;\n}\n\n.grid-header, .grid-cell {\n    height: 50px; /* Stel een vaste hoogte in */\n\n}\n\n.grid-cell {\n    width: 250px;\n}\n\n.icon {\n    height: 30px;\n}\n\n.icon svg {\n    width: 100%;\n    height: auto;\n    \n}\n\n.tableicon {\n    display: inline-block;\n    width: 30px;\n    margin: 0;\n    padding: 0;\n}\n\n.tableicon img {\n    padding-left: 10px;\n    transform: translateY(4px);\n}\n\n.tableicon svg {\n    width: 100%;\n    height: auto;\n}\n\n.mapicon {\n    width: 30px;\n    height: 30px;\n    transition: width 0.3s ease-in-out; /* Smooth transition toegevoegd */\n    cursor: pointer;\n}\n\n.mapicon:hover {\n    width: 35px; /* Breedte iets groter bij hover */\n}\n\n.mapicon svg {\n    width: 100%;\n    height: auto;\n}\n\n.marker {\n    /* background-color: white; */\n    font-family: \"Merriweather\", serif;\n    width: auto;\n    height: 40px;\n    border-radius: 0;\n}\n.marker_text {\n    background-color: white;\n    padding: 10px;\n    font-size: 15px;\n    font-family: \"Merriweather\", serif;\n    color: #001158;\n    border-radius: 10px;\n    display: none;\n}\n\n.tabel_opgemaakt {\n    width: 100%;\n    border-collapse: collapse;\n    font-family: 'VestulaPro-Regular';\n\n}\n\n.popup_img {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    width: 210px;\n\n}\n\n.tabel_opgemaakt th,\n.tabel_opgemaakt td {\n    padding: 8px;\n    text-align: left;\n    border-bottom: 1px solid #001158;\n}\n\n.tabel_opgemaakt th {\n    background-color: #f2f2f2;\n}\n\n.tabel_opgemaakt tr:hover {\n    background-color: #f5f5f5;\n    \n}\n\n.tabel_opgemaakt th {\n    background-color: #f2f2f2;\n    color: #001158;\n}\n\n.tablecontainer {\n    height: 490px;\n    overflow-y: scroll;\n}\n\n.co2::after {\n    content: \"2\";\n    vertical-align: sub;\n    font-size: smaller;\n}\n\n\n.video-container {\n    position: relative;\n    padding-bottom: 56.25%; /* 16:9 aspect ratio */\n    height: 0;\n    overflow: hidden;\n}\n\n.video-container iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.mp4-container {\n    position: relative;\n    padding-bottom: 56.25%; /* 16:9 aspect ratio */\n    height: 0;\n    overflow: hidden;\n}\n\n.mp4-container iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}",".info {\n    position: absolute;\n    top: 90px;\n    width: 94.45%;\n    bottom: 40px;\n    left: 80px;\n    padding-right: 15px;\n    overflow-y: auto!important;\n}\n\n.info .button {\n    display: inline-block;\n    padding: 10px;\n    background-color: #7199f0;\n    color: white;\n    text-decoration: none;\n    border-radius: 10px;\n    margin-top: 10px;\n    margin-bottom: 50vh\n}\n\n.info a:hover {\n    background-color: #555;\n}\n\n/* Scrollbar track */\n.info::-webkit-scrollbar {\n    width: 12px; /* Width of the scrollbar */\n}\n\n.info::-webkit-scrollbar-track {\n    background: #f1f1f1; /* Background of the scrollbar track */\n}\n\n/* Scrollbar thumb */\n.info::-webkit-scrollbar-thumb {\n    background: #888; /* Color of the scrollbar thumb */\n    border-radius: 6px; /* Rounded corners for the scrollbar thumb */\n}\n\n\n.info h1 {\n    font-size: 100px;\n    font-family: \"Montserrat\", sans-serif;\n    color: #0063a4;\n    margin-bottom: 20px;\n}\n\n.info h2 {\n    font-size: 50px;\n    line-height: 52px;\n    margin-bottom: 15px;\n    font-family: \"Montserrat\", sans-serif;\n    color: #0063a4;\n    padding-top: 30px;\n    margin-bottom: 10px;\n}\n\n.info h3 {\n    font-size: 30px;\n    margin-bottom: 10px;\n    font-family: \"Montserrat\", sans-serif;\n    color: #0063a4;\n}\n\n.info h4 {\n    font-size: 30px;\n    background-color: #0063a4;\n    color: white;\n}\n\n.info p, li{\n    font-size: 45px;\n    line-height: 60px!important;\n    font-family: \"Montserrat\", sans-serif;\n    margin-bottom: 10px!important;\n    padding: 0!important;\n}\n\n\n@media screen and (min-width: 1000px) {\n    .info p, li{\n        font-size: 40px;\n        line-height: 60px!important;\n    }\n}\n\n\n\n.info ul {\n    list-style-type: disc;\n    padding-left: 30px;\n\n}\n\n\n",".opening {\n    position: absolute;\n    top: 12px;\n    left: 20px;\n}\n\n.opening h1 {\n    font-family: 'VestulaPro-Bold';\n    font-size: 70px;\n    color: #001158;\n    margin: 0;\n    padding: 0;\n}\n\n.opening p {\n    font-family: \"Merriweather\", serif;\n    font-size: 18px;\n    padding-left: 3px;\n}",".ring-container {\n    position: relative;\n    width: 24px;\n    height: 24px;\n  }\n  \n  .ring {\n    position: absolute;\n    border: 4px solid rgba(255, 0, 0, 0.5);\n    border-radius: 50%;\n    width: 100%;\n    height: 100%;\n    animation: ring-animation 1.5s infinite;\n  }\n  \n  .ring:nth-child(2) {\n    animation-delay: 0.5s;\n  }\n  \n  .ring:nth-child(3) {\n    animation-delay: 1s;\n  }\n  \n  @keyframes ring-animation {\n    0% {\n      transform: scale(0.5);\n      opacity: 1;\n    }\n    50% {\n      opacity: 1;\n    }\n    100% {\n      transform: scale(2);\n      opacity: 0;\n    }\n  }",".startpopup {\n    position: absolute; /* Veranderd naar absolute voor centrering */\n    top: 50%; /* Centreren verticaal */\n    left: 50%; /* Centreren horizontaal */\n    transform: translate(-50%, -50%); /* Aanpassing om precies in het midden te centreren */\n    width: 1500px;\n    height: 850px;\n    z-index: 100;\n    background-color: brown;\n    display: grid;\n    align-items: center; /* Zorgt dat de inhoud ook verticaal gecentreerd is binnen de popup */\n    justify-content: center; /* Zorgt dat de inhoud ook horizontaal gecentreerd is binnen de popup */\n    border-radius: 20px;\n}",".overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 17, 88, 0.5);\n}",".markertext {\n    position: absolute;\n    top: -60px;\n    background-color: white;\n    font-family: 'Oscine', sans-serif;\n    padding: 10px 20px;\n    font-size: 25px;\n    color: black;\n    border-radius: 10px;\n    width: auto;\n}   "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
